import axiosService from "@services/axiosService";
import { IDataResponse } from "@services/interface/IDataResponse";
import "reflect-metadata";
import { injectable } from "inversify";

export interface IStatisticStaffPointService {
  fetchAll(params: any): Promise<IDataResponse<any>>;
  fetch(id: any, params: any): Promise<IDataResponse<any>>;
}

@injectable()
export class StatisticStaffPointService implements IStatisticStaffPointService {
  private prefix: string;

  constructor() {
    this.prefix = "/labs/statistic/staff-point";
  }

  async fetchAll(params: any): Promise<IDataResponse<any>> {
    const response = await axiosService.get(`${this.prefix}`, {
      params: params,
    });
    return response;
  }

  async fetch(id: any, params: any): Promise<IDataResponse<any>> {
    const response = await axiosService.get(`${this.prefix}/${id}`, {
      params: params,
    });
    return response;
  }
}
